import React, { createContext, useReducer } from "react";
import { ScanBarcodeReducer } from "../reducer/ScanBarcodeReducer";

export const ScanBarcodeContext = createContext({});

const initialState = {
  isLoading: false,
  notification: undefined,
  error: false,
};

const ScanBarcodeContextProvider = (props) => {
  const [ScanBarcodeViewModel, ScanBarcodeViewDispatch] = useReducer(
    ScanBarcodeReducer,
    initialState,
    (initialState) => initialState,
  );
  return (
    <ScanBarcodeContext.Provider
      value={{ ScanBarcodeViewModel, ScanBarcodeViewDispatch }}
    >
      {props.children}
    </ScanBarcodeContext.Provider>
  );
};

export default ScanBarcodeContextProvider;



// WEBPACK FOOTER //
// ./src/components/scanBarcode/context/ScanBarcodeContext.js